// the saved comparisons Alpine object
window.appSavedComparisons = () => {
    return {
        comparisons: [],
        leagues: [],

        init: function() {
            this.loadComparisons();
        },

        /*
         * Loads in the saved conparisons from the API
         */
        loadComparisons: function(id) {
            axios.get('/api/saved-comparisons/')
                .then( response => {
                    this.comparisons = response.data;
                })
                .catch( ajaxFail )
        },

        /*
         * Loads in the saved conparisons from the API
         * NO LONGER IN USE - this is loaded via an <a> tag with a dynamically generaled href
         */
        // viewComparison: function(id) {
        //     const c = this.comparisons.find( v => v.id == id );
        //     window.location = buildPath([
        //         'comparison#',
        //         'results',
        //         stringToSlug(c.players[0].name),
        //         stringToSlug(c.players[1].name),
        //         c.players[0].id,
        //         c.players[1].id,
        //         c.season1,
        //         c.season2,
        //         c.stats
        //     ]);
        // },

        /*
         * Deletes the selected comparison from the frontend comparisons list and permentently via the API
         */
        deleteComparison: async function(id) {

            const msg = getLang('confirm_delete_saved_comparison');
            const doDelete = await modalConfirm(msg, 'Delete');

            if( doDelete ) {
                axios.post('/api/saved-comparisons/' + id, {'_method' : 'DELETE'})
                    .then( response => {
                        this.comparisons = this.comparisons.filter( v => v.id !== id );
                        this.selectedPlayers = []
                    })
                    .catch( ajaxFail )
            }
        },
    }
};
